import React, { useState } from 'react';
import styles from "./Form30Page.module.css";
import { Form30Header } from "../../components/Form30/Form30Header/Form30Header";
import { SubUser } from "../../services/models/sub_user";
import { Administrator } from "../../services/models/administrator";
import { Form30Table } from "../../components/Form30/Form30Table/Form30Table";
import { useForm30Sectors } from "../../hooks/useForm30Sectors";
import { useForm30Data } from "../../hooks/useForm30Data";
import {useNavigate} from "react-router-dom";
import {FormActionButton} from "../../components/shared/buttons/FormActionButton";
import stylesButtons from "../../assets/styles/buttons.module.css";

interface Form30PageProps {
    user: Administrator | SubUser | null;
}

const Form30Page: React.FC<Form30PageProps> = ({ user }) => {
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

    // Используем хуки для управления секторами и данными
    const {
        sectors,
        sectorsIsLoading,
        selectedSectorId,
        setSelectedSectorId,
        userIsAdmin,
        userIsRoiv,
    } = useForm30Sectors(user);

    const {
        tableData,
        isLoading,
        isSaving,
        handleTableDataChange,
        handleImportData,
        handleImportAndSave,
        handleSave,
    } = useForm30Data(selectedSectorId, selectedYear);

    let navigate = useNavigate();
    const toDashboard = () => {
        navigate("/administrator/cabinet/form30/dashboard")
    }

    return (
        <div className={styles.contentWrapper}>
            <div className={styles.wrapper}>
                <Form30Header
                    isAdmin={userIsAdmin}
                    isRoiv={userIsRoiv}
                    sectors={sectors}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    onSave={handleSave}
                    isSaving={isLoading || isSaving || sectorsIsLoading}
                    selectedSectorId={selectedSectorId}
                    onSectorChange={setSelectedSectorId}
                    onImport={handleImportData}
                    onImportAndSave={handleImportAndSave}
                />
                
                <Form30Table 
                    data={tableData}
                    onDataChange={handleTableDataChange}
                    isReadOnly={userIsAdmin}
                />

                {userIsAdmin && (
                    <button
                        className={`${stylesButtons.mainButton} ${stylesButtons.iconButton} ${stylesButtons.navigateButtonRight} ${styles.navigateButton}`}
                        onClick={toDashboard}
                    >
                        Переход к дешборду
                    </button>
                )}
            </div>
        </div>
    );
};

export default Form30Page;
